// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__qR1ze","resendInfoText":"OnGoingPaymentBox_resendInfoText__2tZsm"};